import type { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import { type TrackMetadataIntent } from './TrackMetadataIntent';
import { IntentKind } from '@jet-app/music-classical/intents';
import { NetworkError } from '@jet-app/music-classical/utilities';
import { requestTracksMetadata } from '@jet-app/music-classical/api/request-tracks-metadata';
import { transformTrackMetadata } from './transformTrackMetadata';
import type { QueueItemMetadataMap } from './types';

export const TrackMetadataIntentController: IntentController<TrackMetadataIntent> =
    {
        $intentKind: IntentKind.TRACK_METADATA_INTENT,

        async perform(
            intent: TrackMetadataIntent,
            objectGraph: ObjectGraph,
        ): Promise<QueueItemMetadataMap | Object> {
            const { trackIds, queue } = intent;
            const apiResponse = await requestTracksMetadata(
                trackIds,
                objectGraph,
            );

            if (!apiResponse?.body) {
                throw NetworkError.noContent();
            }

            const { trackMetadataMap } = apiResponse?.body;

            return transformTrackMetadata(
                trackMetadataMap,
                queue,
                trackIds,
                objectGraph,
            );
        },
    };
